import React from 'react';
import { sanitizeHtml } from '../../utils/safeHtml';

interface ArticleSchemaProps {
  title: string;
  description: string;
  datePublished: string;
  dateModified?: string;
  url: string;
  image?: string;
  category?: string;
  tags?: string[];
  readingTime?: number;
  wordCount?: number;
}

const ArticleSchema: React.FC<ArticleSchemaProps> = ({
  title,
  description,
  datePublished,
  dateModified,
  url,
  image = "https://talkhaled.com/optimized/Talal-md.webp",
  category = "Technology",
  tags = [],
  readingTime,
  wordCount
}) => {
  
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "description": description,
    "image": image,
    "url": url,
    "datePublished": datePublished,
    "dateModified": dateModified || datePublished,
    "author": {
      "@type": "Person",
      "name": "Talal Alkhaled",
      "url": "https://talkhaled.com/",
      "image": "https://talkhaled.com/optimized/Talal-md.webp",
      "sameAs": [
        "https://github.com/tkkalkhaled",
        "https://www.linkedin.com/in/talal-alkhaled-a0779b321/",
        "https://www.instagram.com/talalal5aled"
      ],
      "description": "Computer Engineer from Michigan State University specializing in AI, web development, and mobile applications."
    },
    "publisher": {
      "@type": "Organization",
      "name": "Talal Alkhaled",
      "url": "https://talkhaled.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://talkhaled.com/optimized/Icon.webp",
        "width": 192,
        "height": 192
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "articleSection": category,
    "articleBody": description,
    ...(tags.length > 0 && {
      "keywords": tags.join(", ")
    }),
    ...(readingTime && {
      "timeRequired": `PT${readingTime}M`
    }),
    ...(wordCount && {
      "wordCount": wordCount
    }),
    "inLanguage": "en-US",
    "isAccessibleForFree": true,
    "audience": {
      "@type": "Audience",
      "audienceType": "Developers, Students, Technology Professionals"
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(JSON.stringify(articleSchema, null, 2))
      }}
    />
  );
};

export default ArticleSchema; 